import { render, staticRenderFns } from "./solicitacaoLista.vue?vue&type=template&id=73af514e"
import script from "./solicitacaoLista.vue?vue&type=script&lang=js"
export * from "./solicitacaoLista.vue?vue&type=script&lang=js"
import style0 from "./solicitacaoLista.vue?vue&type=style&index=0&id=73af514e&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports